import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import AccommodationPage from "@/pages/AccommodationPage";
import AmenitiesPage from "@/pages/AmenitiesPage";
import GalleryPage from "@/pages/GalleryPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import BookPage from "@/pages/BookPage";
import AdminPage from "@/pages/AdminPage";
import PoliciesPage from "@/pages/PoliciesPage";
import SitemapPage from "@/pages/SitemapPage";

function App() {
  return (
    <div className="App bg-sa-bg text-sa-ink min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/accommodation" element={<AccommodationPage />} />
            <Route path="/amenities" element={<AmenitiesPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/policies" element={<PoliciesPage />} />
            <Route path="/sitemap" element={<SitemapPage />} />
            <Route path="/book" element={<BookPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
